import axios from "../../axios";
import { devUrl } from "../../settings";

const state = {
  schemes: [],
  schemesQuantity: null,
  deletingSchemeId: null,
  schemeName: "",
  schemeType: "",
  schemeDescription: "",
  schemeId: "",
  schemeLabels: []
};

const getters = {
  schemes(state) {
    return state.schemes;
  },
  getSchemesQuantity(state) {
    return state.schemesQuantity;
  },
  getSchemesDeletingId(state) {
    return state.deletingId;
  },
  getSchemeName(state) {
    return state.schemeName;
  },
  getSchemeType(state) {
    return state.schemeType;
  },
  getSchemeDescription(state) {
    return state.schemeDescription;
  },
  getSchemeId(state) {
    return state.schemeId;
  },
  getSchemeLabels(state) {
    return state.schemeLabels;
  }
};

const mutations = {
  storeSchemes(state, payload) {
    state.schemes = payload.results;
    state.schemesQuantity = payload.schemesCount;
  },
  storeSchemeModalId(state, payload) {
    state.deletingSchemeId = payload;
  },
  storeSchemeDetails(state, payload) {
    state.schemeName = payload.name;
    state.schemeDescription = JSON.parse(payload.description);
    state.schemeType = payload.type;
    state.schemeId = payload.id;

    if (payload.type !== "form") {
      let labels = [];
      const parsedDescription = JSON.parse(payload.description);
      for (let key in parsedDescription) {
        labels.push({
          key: key,
          value: parsedDescription[key]
        });
      }

      state.schemeLabels = labels;
    }
  },
  changeName(state, payload) {
    state.schemeName = payload;
  },
  changeType(state, payload) {
    state.schemeType = payload;
  },
  changeDescription(state, payload) {
    state.schemeDescription = payload;
  },
  clearSchemeFields(state) {
    state.schemeName = "";
    state.schemeType = "";
    state.schemeDescription = "";
    state.schemeId = "";
    state.schemeLabels = [];
  },
  storeSchemeLabels(state, payload) {
    state.schemeLabels.push({
      key: payload.key,
      value: payload.value
    });
  },
  deleteSchemeLabel(state, payload) {
    state.schemeLabels.splice(payload, 1);
  }
};

const actions = {
  async fetchSchemes({ commit }, page) {
    let res = await axios.get(`/schemes/?limit=5&offset=${5 * page - 5}`);

    commit("storeSchemes", {
      results: res.data.results,
      schemesCount: res.data.count
    });
  },
  async getSchemeById({ commit }, id) {
    let res = await axios.get(`/schemes/${id}`);
    commit("storeSchemeDetails", res.data);
  },
  onNameChange({ commit }, data) {
    commit("changeName", data);
  },
  onTypeChange({ commit }, data) {
    commit("changeType", data);
  },
  onDescriptionChange({ commit }, data) {
    commit("changeDescription", data);
  },
  clearScheme({ commit }) {
    commit("clearSchemeFields");
  },
  postScheme({ dispatch }, data) {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    return axios
      .post("/schemes/", data, config)
      .then(() => {
        dispatch("fetchSchemes", 1);
      })
      .then(() => {
        dispatch("clearScheme");
      })
      .catch(err => console.log(err));
  },
  sendShemeIdToModal({ commit }, id) {
    commit("storeSchemeModalId", id);
  },
  deleteScheme({ dispatch }) {
    const token = localStorage.getItem("token");
    const id = state.deletingSchemeId;

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    axios
      .delete(`${devUrl}schemes/${id}`, config)
      .then(() => {
        dispatch("fetchSchemes", 1);
        dispatch("sendShemeIdToModal", null);
      })
      .catch(err => console.log(err));
  },
  updateScheme({ dispatch }, data) {
    const token = localStorage.getItem("token");
    const id = state.schemeId;

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    axios
      .put(`${devUrl}schemes/${id}/`, data, config)
      .then(() => {
        dispatch("fetchSchemes", 1);
        dispatch("clearScheme");
      })
      .catch(err => console.log(err));
  },
  addSchemeLabel({ commit }, data) {
    commit("storeSchemeLabels", data);
  },
  removeSchemeLabel({ commit }, data) {
    commit("deleteSchemeLabel", data);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
